/**
 * DevExtreme (esm/__internal/scheduler/r1/components/base/group_panel_props.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export const GroupPanelBaseDefaultProps = {
  groupPanelData: {
    groupPanelItems: [],
    baseColSpan: 1
  },
  groupByDate: false,
  styles: {}
};
export const GroupPanelCellDefaultProps = {
  id: 0,
  text: "",
  data: {
    id: 0
  },
  className: ""
};
export const GroupPanelRowDefaultProps = {
  groupItems: [],
  className: ""
};